// ======================================================
//  Weather Wall — Shopify Theme
//  画像パス: Shopify assets/ フラット構造
//  現在: ww01.jpg 〜 ww06.jpg からランダム表示
//  今後: 天気・時間帯ごとにグループを割り当て予定
// ======================================================

// カスタマイザーや他ページでこのスクリプトが読み込まれた場合は何もしない
if (!document.getElementById('loading')) { /* weather-wall 以外のページ */ }
else {

// 将来の天気別グループ定義（画像追加時にここを拡張）
const IMAGE_GROUPS = {
  ww: 6,
};

function pickRandomImage(code, isNight) {
  const count = IMAGE_GROUPS.ww;
  const n     = Math.floor(Math.random() * count) + 1;
  return window.ASSET_BASE + 'ww' + String(n).padStart(2, '0') + '.jpg';
}

function setBgImage(path) {
  document.getElementById('bg-photo').style.backgroundImage = `url('${path}')`;
  const btn = document.getElementById('download-btn');
  if (btn) {
    btn.href     = path;
    btn.download = path.split('/').pop();
    btn.style.display = 'flex';
  }
}

// ── オーバーレイ ──
const OVERLAYS = {
  clear_day:   'rgba(255,200,50,0.06)',
  clear_night: 'rgba(10,10,60,0.35)',
  cloudy:      'transparent',
  rainy:       'rgba(20,40,90,0.40)',
  snowy:       'rgba(200,220,255,0.20)',
  thunder:     'rgba(10,10,40,0.55)',
  foggy:       'rgba(200,210,220,0.35)',
};

function getOverlayKey(code, isNight) {
  if ([0,1].includes(code))                         return isNight ? 'clear_night' : 'clear_day';
  if ([2,3].includes(code))                         return 'cloudy';
  if ([45,48].includes(code))                       return 'foggy';
  if ([51,53,55,61,63,65,80,81,82].includes(code)) return 'rainy';
  if ([71,73,75,77,85,86].includes(code))           return 'snowy';
  if ([95,96,99].includes(code))                    return 'thunder';
  return isNight ? 'clear_night' : 'clear_day';
}

// ── パーティクル Canvas ──
const canvas = document.getElementById('particle-canvas');
const ctx    = canvas.getContext('2d');
let animFrame  = null;
let particleFn = null;

function resizeCanvas() {
  canvas.width  = window.innerWidth;
  canvas.height = window.innerHeight;
}
window.addEventListener('resize', resizeCanvas);
resizeCanvas();

function makeRain(intensity) {
  const drops = Array.from({ length: Math.floor(280 * intensity) }, () => ({
    x: Math.random() * canvas.width, y: Math.random() * canvas.height,
    len: Math.random() * 18 + 8, speed: Math.random() * 9 + 10,
    alpha: Math.random() * 0.35 + 0.2,
  }));
  return function drawRain() {
    const W = canvas.width, H = canvas.height;
    ctx.clearRect(0, 0, W, H);
    ctx.strokeStyle = 'rgba(180,215,255,0.55)'; ctx.lineWidth = 1.2;
    drops.forEach(d => {
      d.y += d.speed; d.x += 1.5;
      if (d.y > H + 10) { d.y = -20; d.x = Math.random() * W; }
      if (d.x > W + 10) d.x = 0;
      ctx.save(); ctx.globalAlpha = d.alpha;
      ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x + d.len * 0.12, d.y + d.len);
      ctx.stroke(); ctx.restore();
    });
  };
}

function makeSnow(intensity) {
  const flakes = Array.from({ length: Math.floor(180 * intensity) }, () => ({
    x: Math.random() * canvas.width, y: Math.random() * canvas.height,
    r: Math.random() * 4 + 1, speed: Math.random() * 1.8 + 0.4,
    drift: Math.random() * 1.4 - 0.7, phase: Math.random() * Math.PI * 2,
    alpha: Math.random() * 0.55 + 0.3,
  }));
  return function drawSnow() {
    const W = canvas.width, H = canvas.height;
    ctx.clearRect(0, 0, W, H);
    flakes.forEach(f => {
      f.phase += 0.012; f.y += f.speed; f.x += f.drift + Math.sin(f.phase) * 0.6;
      if (f.y > H + 8)  { f.y = -8; f.x = Math.random() * W; }
      if (f.x > W + 8)  f.x = -8;
      if (f.x < -8)     f.x = W + 8;
      ctx.save(); ctx.globalAlpha = f.alpha; ctx.fillStyle = 'white';
      ctx.shadowColor = 'rgba(180,220,255,0.6)'; ctx.shadowBlur = 5;
      ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2); ctx.fill();
      ctx.restore();
    });
  };
}

let lightningTimer = 0;
function tickLightning() {
  if (lightningTimer <= 0) return;
  lightningTimer--;
  if (lightningTimer === 0) {
    lightningTimer = Math.floor(Math.random() * 180 + 80);
    const el = document.getElementById('lightning');
    el.style.opacity = '0.85';
    setTimeout(() => {
      el.style.opacity = '0';
      setTimeout(() => { el.style.opacity = '0.5'; setTimeout(() => el.style.opacity = '0', 80); }, 90);
    }, 75);
  }
}

function animate() {
  animFrame = requestAnimationFrame(animate);
  if (particleFn) particleFn();
  else ctx.clearRect(0, 0, canvas.width, canvas.height);
  tickLightning();
}

function setParticles(code) {
  if (animFrame) { cancelAnimationFrame(animFrame); animFrame = null; }
  particleFn = null; lightningTimer = 0;
  if ([51,53,61,80].includes(code))          particleFn = makeRain(0.55);
  else if ([55,63,65,81,82].includes(code))  particleFn = makeRain(1.5);
  else if ([95,96,99].includes(code))      { particleFn = makeRain(2.2); lightningTimer = 60; }
  else if ([71,73,85].includes(code))        particleFn = makeSnow(0.8);
  else if ([75,77,86].includes(code))        particleFn = makeSnow(1.6);
  animate();
}

// ── 天気データ ──
const WMO = {
  0:  { name:'快晴',           emoji:'☀️'  },
  1:  { name:'晴れ',           emoji:'🌤️' },
  2:  { name:'一部曇り',       emoji:'⛅'  },
  3:  { name:'曇り',           emoji:'☁️'  },
  45: { name:'霧',             emoji:'🌫️' },
  48: { name:'霧氷',           emoji:'🌫️' },
  51: { name:'霧雨（弱）',     emoji:'🌦️' },
  53: { name:'霧雨',           emoji:'🌦️' },
  55: { name:'霧雨（強）',     emoji:'🌧️' },
  61: { name:'小雨',           emoji:'🌧️' },
  63: { name:'雨',             emoji:'🌧️' },
  65: { name:'大雨',           emoji:'🌧️' },
  71: { name:'小雪',           emoji:'🌨️' },
  73: { name:'雪',             emoji:'❄️'  },
  75: { name:'大雪',           emoji:'❄️'  },
  77: { name:'霧雪',           emoji:'🌨️' },
  80: { name:'にわか雨（弱）', emoji:'🌦️' },
  81: { name:'にわか雨',       emoji:'🌧️' },
  82: { name:'にわか雨（激）', emoji:'🌧️' },
  85: { name:'にわか雪（弱）', emoji:'🌨️' },
  86: { name:'にわか雪（強）', emoji:'❄️'  },
  95: { name:'雷雨',           emoji:'⛈️' },
  96: { name:'雷雨（ひょう）', emoji:'⛈️' },
  99: { name:'激しい雷雨',     emoji:'⛈️' },
};

async function fetchWeather(lat, lon) {
  const url =
    `https://api.open-meteo.com/v1/forecast` +
    `?latitude=${lat}&longitude=${lon}` +
    `&current=temperature_2m,apparent_temperature,relative_humidity_2m,wind_speed_10m,weather_code,is_day` +
    `&timezone=auto&wind_speed_unit=ms`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Open-Meteo API error');
  return res.json();
}

async function fetchLocationName(lat, lon) {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`,
      { headers: { 'Accept-Language': 'ja' } }
    );
    const d = await res.json();
    const a = d.address;
    return a.city || a.town || a.village || a.county || a.state || '現在地';
  } catch { return '現在地'; }
}

function renderUI(data, place, imagePath) {
  const c       = data.current;
  const code    = c.weather_code;
  const isNight = c.is_day !== 1;
  const wmo     = WMO[code] ?? { name:'不明', emoji:'🌡️' };

  setBgImage(imagePath ?? pickRandomImage(code, isNight));
  document.getElementById('weather-overlay').style.background = OVERLAYS[getOverlayKey(code, isNight)];
  setParticles(code);

  document.getElementById('weather-emoji').textContent = wmo.emoji;
  document.getElementById('temp-value').textContent    = Math.round(c.temperature_2m);
  document.getElementById('weather-desc').textContent  = wmo.name;
  document.getElementById('location-name').textContent = place;
  document.getElementById('feels-like').textContent    = Math.round(c.apparent_temperature);
  document.getElementById('humidity').textContent      = Math.round(c.relative_humidity_2m);
  document.getElementById('wind-speed').textContent    = Math.round(c.wind_speed_10m * 10) / 10;
  document.getElementById('weather-card').style.display = 'block';
}

// ── 時計 ──
function tickClock() {
  const now  = new Date();
  const hh   = String(now.getHours()).padStart(2, '0');
  const mm   = String(now.getMinutes()).padStart(2, '0');
  document.getElementById('clock').textContent = `${hh}:${mm}`;
  const days = ['日','月','火','水','木','金','土'];
  document.getElementById('date-display').textContent =
    `${now.getFullYear()}年${now.getMonth()+1}月${now.getDate()}日（${days[now.getDay()]}）`;
}

// ── 初期化 ──
function setProgress(pct) {
  document.getElementById('progress-bar').style.width = pct + '%';
}

async function weatherWallInit() {
  const loading = document.getElementById('loading');
  const errCard = document.getElementById('error-card');
  loading.classList.remove('fade-out');
  loading.style.display = 'flex';
  errCard.classList.remove('show');
  setProgress(0);

  try {
    setProgress(10);
    const ipRes = await fetch('https://ipapi.co/json/');
    if (!ipRes.ok) throw new Error('位置情報の取得に失敗しました');
    const ipData = await ipRes.json();
    if (ipData.error) throw new Error('位置情報を取得できませんでした（' + (ipData.reason || 'API error') + '）');
    setProgress(35);
    const lat   = ipData.latitude;
    const lon   = ipData.longitude;
    const place = ipData.city || ipData.region || '現在地';

    const [weather] = await Promise.all([
      fetchWeather(lat, lon),
    ]);
    setProgress(70);

    const imagePath = (() => {
      const c = weather.current;
      return pickRandomImage(c.weather_code, c.is_day !== 1);
    })();
    await new Promise(resolve => {
      const img = new Image();
      img.onload = img.onerror = resolve;
      img.src = imagePath;
    });
    setProgress(100);

    await new Promise(r => setTimeout(r, 300));
    renderUI(weather, place, imagePath);
    loading.classList.add('fade-out');
    setTimeout(() => loading.style.display = 'none', 850);
  } catch (err) {
    console.error(err);
    loading.style.display = 'none';
    errCard.classList.add('show');
    document.getElementById('error-msg').textContent =
      err.message || '予期せぬエラーが発生しました。';
  }
}

// ── ショップ遷移アニメーション ──
function goToShop(e) {
  e.preventDefault();
  const url = e.currentTarget.dataset.shopUrl || e.currentTarget.href;
  const centered = new Set(['time-display', 'weather-card']);
  ['time-display', 'weather-card', 'download-btn', 'shop-btn'].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    el.style.opacity    = '0';
    el.style.transform  = centered.has(id) ? 'translateX(-50%) scale(1.06)' : 'scale(1.06)';
  });
  setTimeout(() => {
    const bg = document.getElementById('bg-photo');
    bg.style.transition = 'transform 1.1s ease, opacity 1.1s ease';
    bg.style.transform  = 'scale(1.4)';
    bg.style.opacity    = '0';
  }, 700);
  setTimeout(() => { window.location.href = url; }, 1700);
}

tickClock();
setInterval(tickClock, 15000);
setInterval(weatherWallInit, 600000);
weatherWallInit();

} // end weather-wall guard
